import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';
import Home from '@/app/home/Home.vue';
import Booking from '@/app/booking-page/Booking.vue';
import ThankYou from '@/app/thank-you/ThankYou.vue';
import SearchResultPage from '@/app/search-result-page/search-result-page.component.vue';
import SavedTripsComponent from '@/app/saved-trips/saved-trips.component';
import AffiliateDashboard from "@/app/affiliate/dashboard.vue";
import { TrackingCookie } from "@/app/services/tracking-cookie";
import { AffiliateConfigurationService } from "@/app/services/affiliate-configuration.service";
import { AFFILIATE_COOKIE_NAME } from "@/app/shared/common/constants";

Vue.use(Router);

let routerOptions: RouterOptions = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/booking-page',
      name: 'booking',
      component: Booking,
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      component: ThankYou,
    },
    {
      path: '/search-result/:itinerary?/:solution?',
      name: 'search',
      component: SearchResultPage,
    },
    {
      path: '/saved-trips',
      name: 'saved',
      component: SavedTripsComponent,
    },
    {
      path: '/affiliate',
      name: 'affiliate',
      component: AffiliateDashboard,
    },
    {
      path: '*/ac/:affiliateCode?',
      name: 'affiliate-tracking',
      component: () => {
        // use beforeEach guard
      },
    },
    {
      path: '**',
      name: 'route',
      component: () => {
        const match = location.pathname
          .replace(/\/ac\/([0-9-]+)\/?$/i, '')
          //.match(/^\/?[a-z]{3}(?:-[a-z]{3})+$/i);
          .match(/^\/?[a-z]{3}([0-9]{1,2}[a-z]{3})?(?:[-_][a-z]{3}([0-9]{1,2}[a-z]{3})?)+$/i);
        if (match) {
          return import('../app/home/Home.vue')
        } else {
          return import('../app/404-page/404-page.vue')
        }
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}

let router = new Router(routerOptions);

router.beforeEach(async (to, from, next) => {
  if (to.name === 'affiliate-tracking') {
    const match = to.path.match(/(.*)\/ac\/([0-9-]+)\/?$/i);
    if (match) {
      const affiliateService = new AffiliateConfigurationService();
      new TrackingCookie(AFFILIATE_COOKIE_NAME).set(match[2]);
      const forwardTo = match[1] === '' ? process.env.BASE_URL : match[1];
      await affiliateService.setFromCookie();
      next(forwardTo);
    } else {
      next({ name: 'home' })
    }
  } else {
    next()
  }
});

export default router;
